import {createAction, props} from '@ngrx/store';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';
import {ExportConfigEntity} from '../states/export-config-entities.state';


export class ExportConfigEntitiesActions {

  /**
   * Load export configs for a specific firma (used in detail page)
   */
  public static loadExportConfigsForFirma = createAction(
    '[Export Config Entities] Load export configs for single firma.',
    props<{ firmaId: string }>()
  );

  /**
   * Successfully loaded export configs
   */
  public static loadExportConfigsSuccess = createAction(
    '[Export Config Entities] Load export configs successfully.',
    props<{ exportConfigs: ExportConfigEntity[] }>()
  );

  /**
   * Failed to load export configs
   */
  public static loadExportConfigsFailure = createAction(
    '[Export Config Entities] Load export configs failed.',
    props<{ error: MappedHttpErrorResponse }>()
  );
}
